module.exports = __webpack_public_path__ + "static/media/sub_meal03.4ebcf354.png";